import React from 'react';
import { inject, observer } from 'mobx-react';
import { action, observable } from 'mobx';
import {
	Form,
	Row,
	Field,
	FileInput
} from '@smartplatform/ui';
import t from '../../../i18n';


@inject('store', 'uiStore') @observer
class Edit extends React.Component {

	@observable record = null;
	@observable acls = [];
	@observable isRole = false;


	@observable password = '';
	@observable passwordRepeat = '';
	@observable errors = [];

	constructor(props) {
		super(props);
		this.store = props.store;
		props.uiStore.setBar(<h1>{t('User.title')}</h1>);

		this.loadData();
	}


	@action loadData = async () => {
		console.log('load')
		this.id = this.props.match.params.id;
		if (this.id) {
			this.record = await this.store.User.findById(this.id);
			console.log('user', this.record);
		}
		else {
			this.record = new this.store.User();
		}
	};

	checkRole(props) {
		this.store.RoleMapping && this.store.get(this.store.RoleMapping, {
			where: {
				and: [
					{ principalId: props.match.params.id },
					{ principalType: 'USER' }
				]
			}
		}).then(res => {
			if (res.data.length > 0) {
				this.isRole = true;
				this.deleteAcls();
			}
		});
	};

	deleteAcls() {
		this.store.ACL && this.store.get(this.store.ACL, {
			where: {
				and: [
					{ principalId: this.props.match.params.id },
					{ principalType: 'USER' }
				]
			}
		}).then(res => {
			if (res.data.length > 0) {
				res.data.forEach(acl => {
					acl.delete();
				});
			}
		});
	};

	@action changeAcls = (acls) => {
		this.acls = acls;
	};

	back = () => {
		this.props.history.push(`/admin/users`);
	};

	onChangePassword = e => this.password = e.target.value;
	onChangePasswordRepeat = e => this.passwordRepeat = e.target.value;

	updateACL = () => {
		this.store.ACL && this.acls.forEach(element => {
			let acl = (element.id) ? this.store.getById(this.store.ACL, element.id) : new this.store.ACL;

			acl.model = element.model;
			acl.accessType = element.accessType;
			acl.permission = element.permission;
			acl.principalId = element.principalId;
			acl.principalType = element.principalType;

			acl.save();
		});
	};

	validate = user => {
		this.errors = [];
		if (!user.email || user.email.length === 0) {
			this.errors.push('Введите E-mail');
		}
		if (user.id) {
			if (this.password.length > 0 && this.passwordRepeat.length > 0 && this.password !== this.passwordRepeat) {
				this.errors.push('Пароли не совпадают');
			}
		}
		else {
			if (this.password.length === 0) {
				this.errors.push('Задайте пароль');
			}
			if (this.passwordRepeat.length === 0) {
				this.errors.push('Повторите пароль');
			}
			if (this.password.length > 0 && this.passwordRepeat.length > 0 && this.password !== this.passwordRepeat) {
				if (this.password !== this.passwordRepeat) {
					this.errors.push('Пароли не совпадают');
				}
			}
		}
	};

	beforeSave = async user => {
		this.validate(user);
		if (this.errors.length === 0) {
			if (user.id) {
				if (this.password.length > 0) {
					user.password = this.password;
				}
				else {
					user.password = undefined;
				}
			}
			else {
				user.password = this.password;
			}
		}
		return this.errors.length === 0;
	};

	onSave = () => {
		this.back();
	};

	render() {
		if (!this.record) return '...';

		let writeAllowed;

		if (this.id && this.store.user.id === this.id) {
			writeAllowed = true;
		}
		
		return (
			<div>
				<Form
					record={this.record}
					onDelete={this.back}
					stay
					writeAllowed={writeAllowed}
					beforeSave={this.beforeSave}
					onSave={this.onSave}
				>
					<Row>
						<Field property="lastName" label={t('User.lastName')} />
						<Field property="firstName" label={t('User.firstName')} />
						<Field property="middleName" label={t('User.middleName')} />
					</Row>
					<Row>
						<Field property="username" label={t('User.name')} />
						<Field property="email" required={true} label={t('User.email')} />
						<Field property="emailVerified" label={t('User.emailVerified')} />
					</Row>
					<Row>
						<Field property="telegram" label={t('User.telegram')} />
						<div />
						<div />
					</Row>
					<Row>
						<div className="form-field password">
							<label>{t('Password.new')}</label>
							<input
								type="password"
								autoComplete="new-password"
								value={this.password || ''}
								onChange={this.onChangePassword}
							/>
							<div className="password-hint">
								<i className="admin-icon-info-circled" />
								{t('Password.newHint')}
							</div>
						</div>
						<div className="form-field">
							<label>{t('Password.repeat')}</label>
							<input
								type="password"
								value={this.passwordRepeat || ''}
								onChange={this.onChangePasswordRepeat}
							/>
						</div>
						<div />
					</Row>

					<FileInput property="avatar" label={t('User.avatar')} />
					{this.record.avatar && <div>
						<img src={this.record.downloadFile('avatar')} width={200} height={200} style={{ objectFit: 'contain' }} />
					</div>}
				</Form>

				<div className="form-errors">{this.errors.map((e, i) => <div key={i}>{e}</div>)}</div>
			</div>
		);
	}
}

export default Edit;
